"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.Unit = exports.Timezone = exports.Time = exports.SemVer = exports.Schema = exports.Pagination = exports.Nutrition = exports.Network = exports.Net = exports.Json = exports.Google = exports.Geography = exports.Err = exports.Entity = exports.Date = exports.Culligan = exports.Color = exports.Azure = void 0;
exports.Azure = __importStar(require("./azure"));
exports.Color = __importStar(require("./color"));
exports.Culligan = __importStar(require("./culligan"));
exports.Date = __importStar(require("./date"));
exports.Entity = __importStar(require("./entity"));
exports.Err = __importStar(require("./err"));
exports.Geography = __importStar(require("./geography"));
exports.Google = __importStar(require("./google"));
exports.Json = __importStar(require("./json"));
exports.Net = __importStar(require("./net"));
exports.Network = __importStar(require("./network"));
exports.Nutrition = __importStar(require("./nutrition"));
exports.Pagination = __importStar(require("./pagination"));
exports.Schema = __importStar(require("./schema"));
exports.SemVer = __importStar(require("./semver"));
exports.Time = __importStar(require("./time"));
exports.Timezone = __importStar(require("./timezone"));
exports.Unit = __importStar(require("./unit"));
exports.Utils = __importStar(require("./utils"));
//# sourceMappingURL=index.js.map